import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
//国际化
import zhCn from "element-plus/es/locale/lang/zh-cn";
//webSocket管理类
import WebSocketManager from "./views/utils/WebSocketManager";
import type { SendData } from "@/views/utils/WebSocketClient";
import VideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import http from "@/services/http";
import "./assets/fontFamily/font_f.css";
import "./assets/styles/index.css";
import { getCurrentInstance } from "vue";
import dataV from "@jiaminghi/data-view";

const app = createApp(App);
app.provide("timerTime", 6 * 60 * 1000); //6分钟
import resizeText from "./directive/resizeText";

// 全局注册指令
app.directive("resize-text", resizeText);
const instance = getCurrentInstance();
const baseURL =
  instance?.appContext.config.globalProperties.$baseURL || "localhost:8080";
// 全局注册指令
app.directive("resize-text", resizeText);
// 获取ws单例并初始化
async function initWebSocket() {
  try {
    const wsManager = WebSocketManager.getInstance();
    wsManager.init({
      url: process.env.VUE_APP_WS_URL || "ws://10.9.87.87:3333",
      autoReconnect: true,
      heartbeatInterval: 200000,
    });
    const electronWindow = window.US;
    let eqptName = "";
    if (electronWindow) {
      eqptName = await electronWindow.settingInfo("eqptName");
    }
    // 监听连接成功事件
    wsManager.onGlobal("open", () => {
      console.log("连接成功！可以执行初始化操作了");

      const sendData: SendData = {
        type: "reg", //转发形式 reg | msg
        toClientIp: "", //转发目标客户端
        forwardingType: "txt", //转发形式 txt | hex
        forwardingChannels: "ws", //转发渠道 ws | tcp | udp
        message: eqptName + "_", //消息内容
      };
      wsManager?.sendText(sendData);
    });
    app.provide("wsManager", wsManager);
  } catch (error) {
    console.warn("WebSocket 初始化失败:", error);
  }
}
initWebSocket();
// 将 http 实例设置为全局变量
app.config.globalProperties.$http = http;
app
  .use(store)
  .use(router)
  .use(ElementPlus, {
    locale: zhCn,
  })
  .use(VideoPlayer)
  .use(ElementPlus)
  .use(VideoPlayer)
  .use(dataV)
  .mount("#app");
